import styled from "styled-components";
export const Styles = styled.div`
footer {
  position: relative;
    box-shadow: 0px 0px 10px var(--dark-purple);
    border-radius: 50% 50% 0 0;
    font-size: 10px;
    padding-top: 20px;
    padding-bottom: 5px;
    background-color:#fff;
    z-index:2;
  }
  footer .container {
    padding-inline: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  footer .footer-img {
    width: 100px;
    height: 43.5px;
  }
  footer .footer-img img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
  footer .footer-content .footer-links {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    margin-block-end: 5px;
    white-space: nowrap;
  }
  footer .footer-content .copyrights {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    color: var(--dark-purple);
  }
  footer .footer-content .copyrights .social-media {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
  }
  footer .footer-content .copyrights .social-media a {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 3px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    box-shadow: 0px 0px 40px var(--light-purple);
    font-size: 10px;
  }
  @media (max-width: 768px) {
    footer .container {
      display: block;
      text-align: center;
    }
    footer .footer-content .footer-links {
      margin-block-end: 10px;
      gap: 10px;
    }
    footer .footer-img {
      display: none;
    }
  }
`;